export default __webpack_public_path__ + "static/media/pinch.2c5a1c86.png";